import { useTranslations } from "use-intl";

import { Badge } from "@lawline/ui/components/badge";
import { cn } from "@lawline/ui/core/cn";

import type { WebhookEndpoint } from "../webhooks.types";
import { type EndpointHealth, endpointHealth } from "../webhooks.utils";

const HEALTH_CLASS: Record<EndpointHealth, string> = {
	enabled: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
	failing: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
	disabled: "bg-muted text-muted-foreground",
	gone: "bg-destructive/15 text-destructive",
	disabledFailing: "bg-destructive/15 text-destructive",
};

export function WebhookHealthBadge({ endpoint }: { endpoint: WebhookEndpoint }) {
	const t = useTranslations("webhooks.health");
	const health = endpointHealth(endpoint);
	return <Badge className={cn("border-transparent", HEALTH_CLASS[health])}>{t(health)}</Badge>;
}
